/*
 * Turn an unknown thrown value (typically an `ApiError`) into a user-facing
 * message. FastAPI error bodies are usually `{ detail: string | [...] }`; we
 * coalesce that into a single readable line, falling back to a generic message.
 */

import { ApiError } from "./client";

function detailToMessage(detail: unknown): string | null {
  if (typeof detail === "string") return detail;
  if (Array.isArray(detail)) {
    const parts = detail
      .map((d) => {
        if (d && typeof d === "object" && "msg" in d) {
          return String((d as { msg: unknown }).msg);
        }
        return null;
      })
      .filter((s): s is string => Boolean(s));
    if (parts.length) return parts.join("; ");
  }
  return null;
}

export function errorMessage(err: unknown): string {
  if (err instanceof ApiError) {
    if (err.status === 401) return "Invalid email or password.";
    if (err.status === 403) return "You don't have permission to do that.";
    const body = err.body;
    if (body && typeof body === "object" && "detail" in body) {
      const msg = detailToMessage((body as { detail: unknown }).detail);
      if (msg) return msg;
    }
    return err.message;
  }
  if (err instanceof Error) return err.message;
  return "Something went wrong. Please try again.";
}
